const TechnicalDataEvent = {
  SYSTEM_LAYER_CHANGED: 'technicalDataSystemLayerChanged',
};

export default TechnicalDataEvent;
